var swiper = new Swiper(".single-collection__list", {
    slidesPerView: 3,
    grid: {
        rows: 2,
    },
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {    
        768: {
          slidesPerView: 3
        },
        300: {
          slidesPerView: 2
        },        
    },
});